import { render, staticRenderFns } from "./process-type-step.vue?vue&type=template&id=54b8ebad&"
import script from "./process-type-step.vue?vue&type=script&lang=js&"
export * from "./process-type-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports